/* Reviews, built on Olilu.reviews (olilu.js). Two parts:
   1. [data-review-letters]  The review-letters section. Loads reviews-<file>.json when the section comes near the
      viewport and shows the three newest reviews that have text, at any rating, as letters. The summary is rendered
      in Liquid; with data-mode="js" (a design file without rating metafields) it is filled in here from the file.
   2. [data-reviews-page]    The reviews page. Every imported review from reviews-all.json, newest first by default,
      a page at a time, with sort, star (histogram rows), photo and design filters kept in the URL
      (?stars=5&sort=lowest&photos=1&design=...), a customer-photo strip from reviews-shop.json and a photo lightbox.
   Rows: [rating, text, name, 'Oct 2026', [photo urls], shop reply, product or design title, product handle] */
(function () {
  'use strict';
  var O = window.Olilu;
  if (!O || !O.reviews) return;

  function num(n) { return Number(n || 0).toLocaleString('en-GB'); }
  function hasText(r) { return !!(r && r[1] && String(r[1]).trim()); }
  function sized(url, w, h) {
    var base = String(url || '').split('?')[0];
    return base + '?width=' + w + (h ? '&height=' + h + '&crop=center' : '');
  }
  function photoAlt(r) { return 'Photo from ' + (r[2] || 'an Etsy buyer') + (r[6] ? ', ' + r[6] : ''); }
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  /* Clamp quotes at six lines and add "Read more" only where the text really overflows
     (Olilu.reviews.card clamps by length alone, which misses long quotes in narrow letters). */
  function clamp(root) {
    O.$$('.letter__quote', root).forEach(function (q) {
      if (q.hasAttribute('data-expanded')) return;
      var card = q.parentNode;
      var btn = card.querySelector('[data-review-more]');
      q.classList.add('is-clamped');
      if (q.scrollHeight <= q.clientHeight + 2) {
        q.classList.remove('is-clamped');
        if (btn) btn.remove();
        return;
      }
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'text-cta letter__more';
        btn.setAttribute('data-review-more', '');
        btn.textContent = 'Read more';
        q.insertAdjacentElement('afterend', btn);
      }
    });
  }
  // Remember opened quotes (olilu.js removes the clamp on the document click) so a resize never closes them again.
  function keepExpanded(root) {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-review-more]');
      var q = b && b.parentNode.querySelector('.letter__quote');
      if (q) q.setAttribute('data-expanded', '');
    });
  }

  /* ---------- 1. Review letters ---------- */
  O.ready('[data-review-letters]', function (root) {
    var file = root.getAttribute('data-file') || 'shop';
    var mode = root.getAttribute('data-mode') || 'shop';
    var rail = O.$('[data-rl-rail]', root);
    var nav = O.$('[data-rl-nav]', root);
    if (!rail) return;
    keepExpanded(rail);

    function fail() {
      root.setAttribute('data-state', 'error');
      rail.innerHTML = '';
    }
    function load() {
      return O.reviews.load(file).catch(function (err) {
        // A design without its own review file: show the whole shop, and the summary follows (js mode only).
        if (file === 'shop' || mode !== 'js') throw err;
        return O.reviews.load('shop');
      });
    }
    function fitNav() {
      if (!nav) return;
      nav.hidden = rail.scrollWidth <= rail.clientWidth + 2;
      rail.dispatchEvent(new Event('scroll'));
    }
    function summary(d) {
      var score = O.$('[data-rl-score]', root);
      var hist = O.$('[data-rl-hist]', root);
      if (!score || !d || !d.count) return;
      var avg = Math.round((Number(d.avg) || 0) * 10) / 10;
      score.innerHTML =
        '<p class="review-letters__avg">' + avg.toFixed(1) + '<span class="visually-hidden"> out of 5 stars</span></p>' +
        '<div class="review-letters__meta">' +
          '<span class="stars stars--lg" style="--pct:' + (avg * 20) + '%" aria-hidden="true"></span>' +
          '<p class="review-letters__count">' + num(d.count) + ' ' + O.esc(root.getAttribute('data-count-suffix') || 'Etsy reviews') + '</p>' +
        '</div>';
      score.hidden = false;
      if (hist && d.hist) hist.innerHTML = O.reviews.hist(d.hist);
    }

    O.inView(root, function () {
      load().then(function (d) {
        if (mode === 'js') summary(d);
        var rows = (d.recent || d.r || []).filter(hasText).filter(O.reviews.featurable).slice(0, 3);
        if (!rows.length) { fail(); return; }
        rail.innerHTML = rows.map(function (r) { return O.reviews.card(r, { photos: false }); }).join('');
        root.setAttribute('data-state', 'ready');
        clamp(rail);
        fitNav();
      }).catch(fail);
    });
    window.addEventListener('resize', O.debounce(function () {
      if (root.getAttribute('data-state') !== 'ready') return;
      clamp(rail);
      fitNav();
    }, 200));
  });

  /* ---------- 2. Reviews page ---------- */
  var SORTS = ['newest', 'oldest', 'highest', 'lowest'];

  O.ready('[data-reviews-page]', function (root) {
    var PAGE = Math.max(1, Number(root.getAttribute('data-page-size')) || 12);
    var etsy = root.getAttribute('data-etsy') || '';
    var list = O.$('[data-rv-list]', root);
    if (!list) return;
    var toolbar = O.$('[data-rv-toolbar]', root);
    var status = O.$('[data-rv-status]', root);
    var totalNote = O.$('[data-rv-total]', root);
    var moreWrap = O.$('[data-rv-more-wrap]', root);
    var moreBtn = O.$('[data-rv-more]', root);
    var progress = O.$('[data-rv-progress]', root);
    var sortSel = O.$('[data-rv-sort]', root);
    var photoChk = O.$('[data-rv-photos]', root);
    var designSel = O.$('[data-rv-design]', root);
    var starBtns = O.$$('[data-star]', root);
    var rows = [], view = [], shown = 0, loaded = false;
    var state = fromURL();
    keepExpanded(list);

    function fromURL() {
      var p = new URLSearchParams(location.search);
      var s = { sort: p.get('sort') || 'newest', star: Number(p.get('stars')) || 0, photos: p.get('photos') === '1', design: p.get('design') || '' };
      if (SORTS.indexOf(s.sort) < 0) s.sort = 'newest';
      if (!(s.star >= 1 && s.star <= 5)) s.star = 0;
      return s;
    }
    function toURL() {
      try {
        var u = new URL(location.href);
        ['sort', 'stars', 'photos', 'design'].forEach(function (k) { u.searchParams.delete(k); });
        if (state.sort !== 'newest') u.searchParams.set('sort', state.sort);
        if (state.star) u.searchParams.set('stars', String(state.star));
        if (state.photos) u.searchParams.set('photos', '1');
        if (state.design) u.searchParams.set('design', state.design);
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      } catch (e) { /* the list still works without URL state */ }
    }
    function syncControls() {
      starBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-star')) === state.star)); });
      if (sortSel) sortSel.value = state.sort;
      if (photoChk) photoChk.checked = state.photos;
      if (designSel) designSel.value = state.design;
    }
    function describe() {
      var n = view.length;
      var s = num(n) + ' written ' + (state.star ? state.star + '-star ' : '') + (n === 1 ? 'review' : 'reviews');
      if (state.photos) s += ' with photos';
      if (state.design) s += ' of ' + state.design;
      return s;
    }
    function renderStatus() {
      if (!status) return;
      var active = state.star || state.photos || state.design;
      status.innerHTML = O.esc(describe()) + (active ? '<button type="button" class="text-cta" data-rv-reset>Clear filters</button>' : '');
    }

    function page() {
      var next = view.slice(shown, shown + PAGE);
      if (!view.length) {
        list.innerHTML = '<p class="reviews-page__empty">No written reviews match these filters.<button type="button" class="text-cta" data-rv-reset>Show every review</button></p>';
      } else {
        var tmp = document.createElement('div');
        tmp.innerHTML = next.map(function (x) { return O.reviews.card(x.r); }).join('');
        var nodes = Array.prototype.slice.call(tmp.children);
        nodes.forEach(function (n, k) {
          n.setAttribute('data-rv-i', String(next[k].i));
          list.appendChild(n);
        });
        nodes.forEach(function (n) { clamp(n); });
      }
      shown += next.length;
      if (moreWrap) moreWrap.hidden = shown >= view.length;
      if (progress) progress.textContent = view.length ? 'Showing ' + num(shown) + ' of ' + num(view.length) : '';
    }

    function apply() {
      view = rows.filter(function (x) {
        var r = x.r;
        if (state.star && Number(r[0]) !== state.star) return false;
        if (state.photos && !(r[4] && r[4].length)) return false;
        if (state.design && r[6] !== state.design) return false;
        return true;
      });
      if (state.sort === 'oldest') view.sort(function (a, b) { return b.i - a.i; });
      else if (state.sort === 'highest') view.sort(function (a, b) { return (b.r[0] - a.r[0]) || (a.i - b.i); });
      else if (state.sort === 'lowest') view.sort(function (a, b) { return (a.r[0] - b.r[0]) || (a.i - b.i); });
      shown = 0;
      list.innerHTML = '';
      list.removeAttribute('aria-busy');
      page();
      renderStatus();
      syncControls();
      toURL();
    }
    function reveal() {
      if (!toolbar) return;
      var top = toolbar.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.7) toolbar.scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' });
    }
    function reset() {
      state.star = 0;
      state.photos = false;
      state.design = '';
      if (loaded) apply(); else syncControls();
    }

    starBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var s = Number(b.getAttribute('data-star'));
        state.star = state.star === s ? 0 : s;
        if (loaded) { apply(); reveal(); } else syncControls();
      });
    });
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = SORTS.indexOf(sortSel.value) > -1 ? sortSel.value : 'newest'; if (loaded) apply(); });
    if (photoChk) photoChk.addEventListener('change', function () { state.photos = photoChk.checked; if (loaded) apply(); });
    if (designSel) designSel.addEventListener('change', function () { state.design = designSel.value; if (loaded) apply(); });
    if (moreBtn) moreBtn.addEventListener('click', page);

    syncControls();
    O.reviews.load('all').then(function (d) {
      rows = (d.r || []).filter(hasText).map(function (r, i) { return { r: r, i: i }; });
      var total = Number(d.count) || rows.length;
      if (totalNote && total > rows.length) {
        totalNote.textContent = 'Of ' + num(total) + ' Etsy ratings, ' + num(rows.length) + ' have a written review. The other ' +
          num(total - rows.length) + ' are star ratings only: they count in the bars above but have no card below.';
      }
      if (designSel) {
        var counts = {};
        rows.forEach(function (x) { var t = x.r[6]; if (t) counts[t] = (counts[t] || 0) + 1; });
        Object.keys(counts).sort(function (a, b) { return a.localeCompare(b, 'en-GB'); }).forEach(function (t) {
          var o = document.createElement('option');
          o.value = t;
          o.textContent = t + ' (' + num(counts[t]) + ')';
          designSel.appendChild(o);
        });
        if (state.design && !counts[state.design]) state.design = '';
        designSel.disabled = false;
      }
      loaded = true;
      apply();
    }).catch(function () {
      list.removeAttribute('aria-busy');
      list.innerHTML = '<p class="reviews-page__error">We couldn\'t load the reviews just now. Please refresh the page' +
        (etsy ? ', or read them on <a class="link" href="' + O.esc(etsy) + '" target="_blank" rel="noopener">our Etsy shop</a>' : '') + '.</p>';
      if (status) status.textContent = '';
    });

    /* Customer photo strip (reviews-shop.json 'photos': every review with a photo, newest first) */
    var strip = O.$('[data-rv-strip]', root);
    var stripWrap = O.$('[data-rv-strip-wrap]', root);
    var photos = [];
    if (strip && stripWrap) {
      O.reviews.load('shop').then(function (d) {
        photos = (d.photos || []).filter(function (r) { return r && r[4] && r[4].length; });
        if (!photos.length) return;
        strip.innerHTML = photos.map(function (r, n) {
          var u = r[4][0];
          return '<a class="reviews-page__photo" href="' + O.esc(sized(u, 1600)) + '" target="_blank" rel="noopener" data-rv-photo="' + n + '">' +
            '<img src="' + O.esc(sized(u, 256, 256)) + '" alt="' + O.esc(photoAlt(r)) + '" width="128" height="128" loading="lazy"></a>';
        }).join('');
        stripWrap.hidden = false;
        strip.dispatchEvent(new Event('scroll'));
      }).catch(function () { /* no strip */ });
    }

    /* Photo lightbox: the photo with its review; prev/next steps through the strip */
    var dialog = O.$('[data-rv-dialog]', root);
    var canDialog = !!(dialog && typeof dialog.showModal === 'function');
    var dImg = dialog && O.$('[data-rv-dialog-img]', dialog);
    var dText = dialog && O.$('[data-rv-dialog-text]', dialog);
    var dCount = dialog && O.$('[data-rv-dialog-count]', dialog);
    var dPrev = dialog && O.$('[data-rv-prev]', dialog);
    var dNext = dialog && O.$('[data-rv-next]', dialog);
    var lb = { items: [], n: 0, opener: null };

    function show(n) {
      var it = lb.items[n];
      if (!it) return;
      lb.n = n;
      dImg.src = sized(it.url, 1400);
      dImg.alt = photoAlt(it.r);
      dText.innerHTML = O.reviews.card(it.r, { photos: false });
      O.$$('.is-clamped', dText).forEach(function (q) { q.classList.remove('is-clamped'); });
      O.$$('[data-review-more]', dText).forEach(function (b) { b.remove(); });
      var many = lb.items.length > 1;
      dCount.textContent = many ? 'Photo ' + (n + 1) + ' of ' + lb.items.length : 'Customer photo';
      dPrev.hidden = dNext.hidden = !many;
      dPrev.disabled = n === 0;
      dNext.disabled = n === lb.items.length - 1;
    }
    function open(items, n, opener) {
      if (!canDialog || !items.length) return false;
      lb.items = items;
      lb.opener = opener;
      show(n);
      if (!dialog.open) {
        dialog.showModal();
        O.lock(true);
      }
      return true;
    }
    if (canDialog) {
      dialog.addEventListener('close', function () {
        O.lock(false);
        if (lb.opener && lb.opener.focus) lb.opener.focus({ preventScroll: true });
      });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft' && lb.n > 0) show(lb.n - 1);
        if (e.key === 'ArrowRight' && lb.n < lb.items.length - 1) show(lb.n + 1);
      });
      dPrev.addEventListener('click', function () { show(lb.n - 1); });
      dNext.addEventListener('click', function () { show(lb.n + 1); });
      O.$('[data-rv-close]', dialog).addEventListener('click', function () { dialog.close(); });
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-rv-reset]')) { reset(); return; }
      var a = e.target.closest('[data-rv-photo]');
      if (a) {
        var items = photos.map(function (r) { return { r: r, url: r[4][0] }; });
        if (open(items, Number(a.getAttribute('data-rv-photo')) || 0, a)) e.preventDefault();
        return;
      }
      var p = e.target.closest('.letter__photos a');
      if (p && list.contains(p)) {
        var card = p.closest('[data-rv-i]');
        var x = card && rows[Number(card.getAttribute('data-rv-i'))];
        if (!x) return;
        var links = O.$$('.letter__photos a', card);
        var shots = (x.r[4] || []).slice(0, links.length).map(function (u) { return { r: x.r, url: u }; });
        if (open(shots, Math.max(0, links.indexOf(p)), p)) e.preventDefault();
      }
    });
  });
})();
